export { SocialsBanner } from './SocialsBanner';
